/** 过滤不可达的占位头像外链，返回空字符串以便 UI 回退到姓名首字。 */
export function sanitizeAvatarUrl(url?: string | null): string {
  const raw = String(url || '').trim();
  if (!raw) return '';
  if (/via\.placeholder\.com|placehold\.(co|it)/i.test(raw)) return '';
  return raw;
}
